import styled from 'styled-components';

const Label = styled.label`
	font-size: 12px;
  color: #333333;
  font-family: Montserrat-Bold;
  font-weight: bold;
  padding-left: 10px;
`;

export default Label;
